import React, { useState } from 'react';
import {
  Drawer,
  IconButton,
  useTheme,
  useMediaQuery,
  Box,
  Toolbar,
  Stack
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import WorkshopDrawerContent from './WorkshopDrawerContent';

const drawerWidth = 240;

interface WorkshopDrawerProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const WorkshopDrawer: React.FC<WorkshopDrawerProps> = ({
  mobileOpen = false,
  onMobileClose
}) => {
  const [open, setOpen] = useState(true); // Desktop drawer state
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Mobile drawer
  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#fafafa",
            borderRight: "1px solid #f0f0f0",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px"
          }
        }}
      >
        {/* Close button inside drawer */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={onMobileClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <WorkshopDrawerContent />
      </Drawer>
    );
  }

  // Desktop drawer
  return (
    <div>
      <IconButton
        onClick={() => setOpen(!open)}
        sx={{
          m: 1,
          display: { xs: 'none', md: 'flex' }
        }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        variant="persistent"
        open={open}
        sx={{
          width: open ? drawerWidth : 0,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            transition: 'width 0.3s',
            overflowX: 'hidden',
            backgroundColor: "#fafafa",
            borderRight: "1px solid #f0f0f0",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px"
          }
        }}
      >
        {/* Close button inside drawer */}
        <WorkshopDrawerContent />
      </Drawer>
    </div>
  );
};

export default WorkshopDrawer;
